// extracted by mini-css-extract-plugin
module.exports = {"item":"item__q15GE","tableDiv":"tableDiv__19rPt","borderTop":"borderTop__3rPsh","borderBottom":"borderBottom__3gfU2","line":"line__39GI7"};